// export const HOST = 'https://prasanna-gramopadhye.com:5000'
export const HOST = 'https://online-exam-portal.onrender.com'